loadVehicleServiceTypeEvents = () => {
  $(document).on('show.bs.dropdown', '.vehicle-service .dropdown', function() {
    let dropdown = $(this);
    let menu = dropdown.find('.custom-dropdown-menu');
    let hiddenFieldId = dropdown.closest('.form-group').find('input[data-target=hidden-field]').attr('id');
    let selectedValue = $(`#${hiddenFieldId}`).val();

    $.ajax({
      url: '/vehicle_service_types',
      method: 'GET',
      dataType: 'json',
      success: function(serviceTypes) {
        menu.find('li.dropdown-item').not('.custom-input, .custom-trigger').remove();

        let items = serviceTypes.map(function(serviceType) {
          let selectedClass = String(serviceType.id) === String(selectedValue) ? ' selected' : '';
          return `
            <li class="dropdown-item d-flex justify-content-between align-items-center${selectedClass}"
                data-key="${serviceType.name}"
                data-value="${serviceType.id}"
                data-input-target="${hiddenFieldId}">
              ${serviceType.name}
              <i class="fa fa-close remove-vehicle-service-type" style="cursor: pointer;" data-service-type-id="${serviceType.id}"></i>
            </li>
          `;
        });

        menu.find('.custom-input').before(items.join(''));
      },
      error: function() {
        alert('Failed to load Service Types. Please try again.');
      }
    });
  });

  $(document).on('click', '.custom-trigger', function(e) {
    // Show the inline input field
    let input = $(this).closest('.dropdown-menu').find('.custom-input');
    if (input.css('display') === 'none') {
      input.css('display', 'block');
    } else {
      input.css('display', 'none');
    }
  });

  $(document).on('keydown', '.new-vehicle-service-input', function(e) {
    if(e.key !== 'Enter') return;

    const newServiceType = e.target.value.trim();

    if (newServiceType === "") return;

    let menu = $(this).closest('.dropdown-menu');
    // newly added service_type need data-input-target to responsd to item select
    let serviceTypeIdFieldId = $(this).closest('div.form-group').find('input[data-target=hidden-field]').attr('id');
    let input = $(e.target);

    $.ajax({
      url: '/vehicle_service_types',
      method: 'POST',
      data: { vehicle_service_type: { name: newServiceType } },
      dataType: "json",
      success: function (response) {
        let newItem = $(`
          <li class="dropdown-item d-flex justify-content-between align-items-center" 
              data-key="${response.name || newServiceType}" 
              data-value="${response.id || newServiceType}"
              data-input-target="${serviceTypeIdFieldId}">
            ${response.name || newServiceType}
            <i class="fa fa-close remove-vehicle-service-type" style="cursor: pointer;" data-service-type-id="${response.id}"></i>
          </li>
        `);

        menu.find('.custom-input').before(newItem);

        // Reset input and toggle UI
        input.val("");
        menu.find('.custom-input').css('display', 'none');
        menu.find('.custom-trigger').click();
      },
      error: function () {
        alert("Failed to add a new Service Type. Please try again.");
      }
    });
  });

  $(document).on('click', '.remove-vehicle-service-type', function(e) {
    let li = $(this).closest('li');
    let serviceTypeID = e.target.dataset.serviceTypeId;

    $.ajax({
      url: `/vehicle_service_types/${serviceTypeID}`,
      method: 'DELETE',
      dataType: "json",
      success: function(response) {
        li.remove(); 
      },
      error: function() {
        alert("Failed to remove Service Type. Please try again.");
      }
    });
  });
}
